<template>
    <mm-select :options="options"
    v-bind="$attrs" :value="value" v-on="$listeners" />
</template>

<script>
export default {
	data(){
		const options = ['cpa_channel','traffic_source','media_channel','api_channel','api_publisher'].map(v => {
            let name = '';
            const v_arr = v.split('_');
            name = v_arr[0].toUpperCase() + ' ' + v_arr[1].substring(0,1).toUpperCase() + v_arr[1].substring(1);
			return { value: v, label: name };
		});
		return{
			options,
		}
	},
	props:['value'],
}
</script>

